module.exports = __webpack_public_path__ + "static/media/apple.72d85d37.svg";